// Pure Toggle-Logik für kommaseparierte URL-Filter-Werte (Multi-Select-
// Facetten in der FilterBar). `current` = der rohe URL-Param-String (z.B.
// "a,b"), `id` wird ein-/ausgeschaltet. Rückgabe = neuer kommaseparierter
// String, ODER '' wenn die Liste leer ist (Caller löscht dann den Param,
// hält die URL clean). Leere/whitespace-Segmente werden gefiltert.
export function toggleCsv(current: string, id: string): string {
  const list = current.split(',').filter(Boolean);
  const next = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
  return next.join(',');
}
